import React, { Fragment, useEffect, useState } from 'react'
import './recipes.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { getRecipes, getRecipeNutritions, getNextRecipes, resetRecipes, resetRecipeLoader, getPlatingImages, getImageUsingTxts, getPackagingImages, getPackagingImageUsingTxts, getRecipeImages, addRecipeFavorites } from '../../Redux/ActionCreators/homepageAction';
import Slider from 'react-slick';
import { Accordion, Modal } from 'react-bootstrap';
import Lightbox from '../../utils/lightBox';
import { Helmet } from 'react-helmet';


export default function Recipes() {
    const [page, setPage] = useState(1);
    const [active, setActive] = useState('-1');
    const [openBox, setOpenBox] = useState(false);
    const [image, setImage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingPlateImg, setIsLoadingPlateImage] = useState(false);
    const [isLoadingPkgImg, setIsLoadingPkgImage] = useState(false);
    const [count, setCount] = useState(0);
    const [isLogin, setIsLogin] = useState(false);
    const [packagingInput, setPackagingInput] = useState('');
    const [platingInput, setPlatingInput] = useState('');
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { recipes, hash, isLoadingRecipe, recipeComplete } = useSelector(state => state.home);

    useEffect(() => {
        window.scrollTo(0, 0);
        window.onbeforeunload = function () {
            window.scrollTo(0, 0);
        };
        const firstRender = async () => {
            await dispatch(resetRecipes());
            const { ...newObj } = location.state.inputData;
            const res = await dispatch(getRecipes(newObj));
            if (res?.type === 'GET_RECIPES') {
                for (var i = 0; i < res.payload.rows?.length; i++) {
                    await dispatch(getRecipeImages(res.payload.rows[i], i));
                }
                await setCount(0);
            }
        }
        firstRender();
    }, [])

    const getMoreRecipes = async () => {
        await dispatch(resetRecipeLoader());
        setPage(page + 1)
        let inputData = {
            activeMasterCatalog: location.state.inputData?.activeMasterCatalog,
            activeMasterSlug: location.state.inputData?.activeMasterSlug,
            activeCatalog: location.state.inputData.activeCatalog,
            activeSubCatalog: location.state.inputData.activeSubCatalog,
            subCataLogRemark: location.state.inputData.subCataLogRemark,
            activeCuisine: location.state.inputData.activeCuisine,
            cuisineRemark: location.state.inputData.cuisineRemark,
            activeProductTypes: location.state.inputData.activeProductTypes,
            productTypeRemark: location.state.inputData.productTypeRemark,
            activeProducts: location.state.inputData.activeProducts,
            productRemark: location.state.inputData.productRemark,
            shelfLife: location.state.inputData.shelfLife,
            servingSize: location.state.inputData.servingSize,
            nutritionInstitution: location.state.inputData.nutritionInstitution,
            otherNotes: location.state.inputData.otherNotes,
            keyword: location.state.inputData.keyword,
            page: page + 1,
            hash: hash,
        }
        const res = await dispatch(getNextRecipes(inputData));
        if (res?.type === 'GET_NEXT_RECIPES') {
            const rec = recipes.concat(res.payload.rows?.map(el => [{ ...el, recipe_image: '/images/placeholder-image.gif', images: [] }][0]))
            let start = count + res.payload.rows?.length
            for (var i = start; i < rec?.length; i++) {
                await dispatch(getRecipeImages(rec[i], i));
            }
        }
    }

    const getRecipeNutrition = async (detail, i) => {
        await setIsLoading(true);
        await dispatch(getRecipeNutritions(detail, i, 'recipe'));
        await setIsLoading(false);
    }

    const getPlatingImage = async (detail, i) => {
        await setIsLoadingPlateImage(true);
        await dispatch(getPlatingImages(detail, i, 'recipe'));
        await setIsLoadingPlateImage(false);
    }

    const getImageUsingTxt = async (name, val, i) => {
        await setIsLoadingPlateImage(true);
        await dispatch(getImageUsingTxts(name, val, i, 'recipe'));
        await setPlatingInput('');
        await setIsLoadingPlateImage(false);
    }

    const getPackagingImage = async (detail, i) => {
        await setIsLoadingPkgImage(true);
        await dispatch(getPackagingImages(detail, i, 'recipe'));
        await setIsLoadingPkgImage(false);
    }

    const getPackagingImageUsingTxt = async (name, val, i) => {
        await setIsLoadingPkgImage(true);
        await dispatch(getPackagingImageUsingTxts(name, val, i, 'recipe'));
        await setPackagingInput('');
        await setIsLoadingPkgImage(false);
    }

    const goBack = () => {
        navigate('/')
    }

    const recipeloaderImages = [
        './images/loader-images/recipes/loader.gif',
        './images/loader-images/recipes/1.png',
        './images/loader-images/recipes/2.png',
        './images/loader-images/recipes/loader.gif',
        './images/loader-images/recipes/3.png',
        './images/loader-images/recipes/4.png',
        './images/loader-images/recipes/loader.gif',
        './images/loader-images/recipes/5.png',
        './images/loader-images/recipes/6.png',
        './images/loader-images/recipes/loader.gif',
        './images/loader-images/recipes/7.png',
        './images/loader-images/recipes/8.png',
        './images/loader-images/recipes/loader.gif',
        './images/loader-images/recipes/9.png',
        './images/loader-images/recipes/10.png',
        './images/loader-images/recipes/loader.gif',
    ];

    var settings = {
        speed: 4000,
        autoplay: true,
        fade: true,
        pauseOnHover: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    };

    const handleAccordion = (i) => {
        if (Number(active) === i) {
            setActive(-1);
        } else {
            setActive(i);
        }
    }

    const openImage = (e, img) => {
        e.preventDefault();
        e.stopPropagation();
        setOpenBox(true);
        setImage(img)
    }

    const marked = async (el, idx, id, val) => {
        if (!localStorage.getItem('userAuthToken')) {
            setIsLogin(true);
        } else {

            let obj = {
                "recipeId": id,
                "isFavorite": val,
                recipeData: val ? el : {}
            }
            await dispatch(addRecipeFavorites(obj, idx));
        }
    }

    return (
        < div className='content-holder' >
            <Helmet>
                <meta charSet="utf-8" />
                <title>Recipes | Healthy Dinner, Vegan, Desserts & More | Nutrainn</title>
                <meta name="description" content="Discover a wide range of recipes on Nutrainn! Browse healthy recipes for dinner, weight loss diets, vegan dishes, and quick snacks." />
                <link rel="canonical" href="https://www.nutrainn.com/recipes" />
            </Helmet>
            <div className='banner-image' >
                <img src={'./images/background-images/recipes.jpg'} alt='' />
                <h5>{'Formulation'}</h5>
            </div>

            {
                <div className="content">
                    {
                        //For Recipes
                        (recipes ?
                            <Accordion defaultActiveKey={`${active}`} id='accord' >
                                {
                                    recipes?.map((el, i) => {
                                        return (
                                            <Accordion.Item key={i} eventKey={`${i}`}>
                                                <Accordion.Header className={Number(active) === i ? 'active-acc' : ''} onClick={() => handleAccordion(i)}>
                                                    <div className='d-flex justify-content-between w-100 flex-wrap' style={{ background: Number(active) === i ? '#F3FBFD' : '' }}>
                                                        <div className={window.innerWidth > 767 ? 'w-50' : 'w-100'}>
                                                            <h2 className='d-flex justify-content-between'>{el?.recipe_name}
                                                                {el.isFavorite ?
                                                                    <img src='./svg-icons/heart-filled.svg' alt='' width={30} onClick={(e) => {
                                                                        e.preventDefault()
                                                                        e.stopPropagation()
                                                                        marked(el, i, el.recipeId, false)
                                                                    }} /> : <img src='./svg-icons/favorite-active-icon.svg' alt='' width={30} onClick={(e) => {
                                                                        e.preventDefault()
                                                                        e.stopPropagation()
                                                                        marked(el, i, el.recipeId, true)
                                                                    }} />} </h2>
                                                            <h4>({el.serving_size} Servings, {el.shelf_life} Shelf-life)</h4>
                                                            {window.innerWidth < 767 &&
                                                                <div className='recipe-img-box'>
                                                                    <img src={el.recipe_image} alt='' className='recipe-img' />
                                                                </div>
                                                            }
                                                            <div className='mt-4'>
                                                                {
                                                                    el.ingredients && (
                                                                        <div>
                                                                            <h3>Ingredients:</h3>
                                                                            <p dangerouslySetInnerHTML={{ __html: el.ingredients.replaceAll("\n", "<br>") }}></p>
                                                                        </div>
                                                                    )
                                                                }

                                                            </div>
                                                        </div>
                                                        {window.innerWidth > 767 ?
                                                            <Fragment>
                                                                <div className={window.innerWidth > 767 ? 'w-50' : 'w-100'}>
                                                                    <div className='recipe-img-box'>
                                                                        <img src={el.recipe_image} alt='' className='recipe-img' onClick={(e) => window.innerWidth > 767 ? openImage(e, el.recipe_image) : null} />

                                                                    </div>
                                                                </div>

                                                            </Fragment> :
                                                            null
                                                        }
                                                    </div>

                                                </Accordion.Header>
                                                <Accordion.Body className={Number(active) === i ? 'active-acc-body' : ''}>
                                                    <div className='row'>
                                                        <div className='col-md-6 col-12'>
                                                            <div className='mt-4'>
                                                                {
                                                                    el.other_ingredients && (
                                                                        <div className='mt-2'>
                                                                            <h3>Other Ingredients:</h3>
                                                                            <p dangerouslySetInnerHTML={{ __html: el.other_ingredients.replaceAll("\n", "<br>") }}></p>
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>
                                                            <div className='mt-4'>
                                                                {
                                                                    el.instructions && (
                                                                        <div>
                                                                            <h3>Instructions:</h3>
                                                                            <p dangerouslySetInnerHTML={{ __html: el.instructions.replaceAll("\n", "<br>") }}></p>
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>
                                                            <div className='mt-4'>
                                                                {
                                                                    el.bacteria_removal_procedures && (
                                                                        <div>
                                                                            <h3>Bacteria Removal Procedures:</h3>
                                                                            <p dangerouslySetInnerHTML={{ __html: el.bacteria_removal_procedures.replaceAll("\n", "<br>") }}></p>
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>
                                                            <div className='mt-4'>
                                                                {
                                                                    el.safe_handling && (
                                                                        <div>
                                                                            <h3>Safe Handling:</h3>
                                                                            <p dangerouslySetInnerHTML={{ __html: el.safe_handling.replaceAll("\n", "<br>") }}></p>
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>
                                                            <div className='mt-4'>
                                                                {
                                                                    el.optimization_efficiencies && (
                                                                        <div>
                                                                            <h3>Optimization & Efficiencies:</h3>
                                                                            <p dangerouslySetInnerHTML={{ __html: el.optimization_efficiencies.replaceAll("\n", "<br>") }}></p>
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>
                                                            <div className='mt-4'>
                                                                {
                                                                    (
                                                                        <div>
                                                                            <h3>Packaging :</h3>
                                                                            {el.material_methodology &&
                                                                                <div className='mt-3'>
                                                                                    <h3>Material & Methodology</h3>
                                                                                    <p dangerouslySetInnerHTML={{ __html: el.material_methodology.replaceAll("\n", "<br>") }}></p>
                                                                                </div>
                                                                            }
                                                                            {el.product_package_dimensions &&
                                                                                <div className='mt-3'>
                                                                                    <h3>Product & Package Dimensions</h3>
                                                                                    <p dangerouslySetInnerHTML={{ __html: el.product_package_dimensions.replaceAll("\n", "<br>") }}></p>
                                                                                </div>
                                                                            }
                                                                            {el.package_wrap_labeling &&
                                                                                <div className='mt-3'>
                                                                                    <h3>Package Wrap Labeling</h3>
                                                                                    <p>
                                                                                        {el?.package_wrap_labeling.map((item, index) => <div key={index}>{(index + 1) + ". " + item}</div>)}
                                                                                    </p>
                                                                                    {!el?.packageWrapImages?.length ?
                                                                                        <div className='view-img'>
                                                                                            <button onClick={() => getPackagingImage(el, i)} disabled={isLoadingPkgImg}>{isLoadingPkgImg ? 'Loading Images ...' : 'View Images'}</button>
                                                                                        </div> :
                                                                                        null
                                                                                    }
                                                                                    {el?.packageWrapImages?.length ?
                                                                                        <div className='d-flex flex-wrap'>
                                                                                            {el?.packageWrapImages?.map((image, index) => {
                                                                                                return (
                                                                                                    <div key={index} className={(window.innerWidth > 767 ? 'col-md-2 col-6 ps-0 padd mt-2' : 'col-md-2 col-6 ps-0 padd1 mt-2')} >
                                                                                                        <img src={image} alt='' className='plating-img' onClick={(e) => window.innerWidth > 767 ? openImage(e, image) : null} />
                                                                                                    </div>
                                                                                                )
                                                                                            })}
                                                                                        </div>
                                                                                        :
                                                                                        null
                                                                                    }
                                                                                    {el?.packageWrapImages?.length ?
                                                                                        <div className='add-box mt-4'>
                                                                                            <input type='text' className='form-control' placeholder='Enter custom prompt to get image...' value={packagingInput} onChange={(e) => setPackagingInput(e.target.value)} />&nbsp;&nbsp;
                                                                                            <button onClick={() => getPackagingImageUsingTxt(el.recipe_name, packagingInput, i)} disabled={(isLoadingPkgImg || packagingInput === '') ? true : false}>{isLoadingPkgImg ? 'Loading...' : 'Get Image'}</button>
                                                                                        </div> :
                                                                                        null
                                                                                    }
                                                                                </div>
                                                                            }

                                                                        </div>
                                                                    )
                                                                }
                                                            </div>


                                                        </div>
                                                        <div className='recipe-right col-md-6 col-12'>
                                                            <div className='mt-4'>
                                                                {el?.nutrition_facts && (
                                                                    <div>
                                                                        <h3>Nutrition Facts:</h3>
                                                                        <p dangerouslySetInnerHTML={{ __html: el?.nutrition_facts.replaceAll("\n", "<br>") }}></p>

                                                                        <p className='reference-links'>
                                                                            {el?.references_sources.map((item, index) => <>
                                                                                <a href={item} target='_blank' rel="noreferrer" key={index}>{"Reference " + (index + 1)}</a>
                                                                                <br></br>
                                                                            </>)}
                                                                        </p>
                                                                    </div>
                                                                )}

                                                                {!el.nutrition_facts && (
                                                                    <div className='view-img'>
                                                                        <button onClick={() => getRecipeNutrition(el, i)} disabled={isLoading}>{isLoading ? 'Loading Data ...' : 'View Nutritions'}</button>
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div className='mt-4'>
                                                                {
                                                                    el.suggestions && (
                                                                        <div>
                                                                            <h3>Suggestions</h3>
                                                                            <p dangerouslySetInnerHTML={{ __html: el.suggestions.replaceAll("\n", "<br>") }}></p>
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>
                                                            <div className='mt-4'>
                                                                {
                                                                    el.wellness_tips && (
                                                                        <div>
                                                                            <h3>Wellness Tips</h3>
                                                                            <p dangerouslySetInnerHTML={{ __html: el.wellness_tips.replaceAll("\n", "<br>") }}></p>
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>
                                                            <div className='mt-4'>
                                                                {
                                                                    el.plating_creativity && (
                                                                        <div>
                                                                            <h3>Plating Creativity</h3>
                                                                            <p>
                                                                                {el?.plating_creativity.map((item, index) => <div key={index}>{(index + 1) + ". " + item}</div>)}
                                                                            </p>
                                                                            {!el?.images?.length ?
                                                                                <div className='view-img'>
                                                                                    <button onClick={() => getPlatingImage(el, i)} disabled={isLoadingPlateImg}>{isLoadingPlateImg ? 'Loading Images ...' : 'View Images'}</button>
                                                                                </div> :
                                                                                null
                                                                            }
                                                                            {el?.images?.length ?
                                                                                <div className='d-flex flex-wrap'>
                                                                                    {el?.images?.map((image, index) => {
                                                                                        return (
                                                                                            <div key={index} className={(window.innerWidth > 767 ? 'col-md-2 col-6 ps-0 padd mt-2' : 'col-md-2 col-6 ps-0 padd1 mt-2')} >
                                                                                                <img src={image} alt='' className='plating-img' onClick={(e) => window.innerWidth > 767 ? openImage(e, image) : null} />
                                                                                            </div>
                                                                                        )
                                                                                    })}
                                                                                </div>
                                                                                :
                                                                                null
                                                                            }
                                                                            {el?.images?.length ?
                                                                                <div className='add-box mt-4'>
                                                                                    <input type='text' className='form-control' placeholder='Enter custom prompt to get image...' value={platingInput} onChange={(e) => setPlatingInput(e.target.value)} />&nbsp;&nbsp;
                                                                                    <button onClick={() => getImageUsingTxt(el.recipe_name, platingInput, i)} disabled={(isLoadingPlateImg || platingInput === '') ? true : false}>{isLoadingPlateImg ? 'Loading...' : 'Get Image'}</button>
                                                                                </div>
                                                                                : null
                                                                            }
                                                                        </div>
                                                                    )
                                                                }


                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className={window.innerWidth > 767 ? 'row mt-4 ms-2' : 'row ps-0 mt-4'}>

                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        )
                                    })
                                }
                            </Accordion > :
                            null)


                    }
                    {
                        isLoadingRecipe ?
                            <div className='text-center'>
                                <Slider {...settings}>
                                    {recipeloaderImages?.map((el, index) => {
                                        return (
                                            <div key={index} className={index === 0 ? "carousel-item active" : "carousel-item"}>
                                                <img src={el} className="d-block loader-img" alt="..." />
                                            </div>
                                        )
                                    })
                                    }
                                </Slider>
                            </div>
                            :
                            recipes?.length === 0 ?
                                <div className='no-recipes-found'>No data found<br /><br />
                                    <button className='go-back-btn' onClick={goBack}>Go Back</button>
                                </div> :

                                <div className='text-center'>
                                    {
                                        (recipeComplete) ? null :
                                            <button className='more-btn' onClick={getMoreRecipes}>Get More Recipes</button>

                                    }
                                    &nbsp;&nbsp; <button className='go-back-btn' onClick={goBack}>Go Back</button>
                                </div>
                    }

                </div >
            }
            {/* ########################## Lightbox modal ####################### */}
            <Lightbox
                openBox={openBox}
                image={image}
                closeBox={() => setOpenBox(false)}
            />

            {/* ########## Redirect to login ############### */}
            <Modal
                show={isLogin}
                size={"md"}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                // onHide={this.handleCloseModal}
                dialogClassName={"confirm-modal"}
            >
                <div className="p-4" >
                    <h1>
                        Please login to favorite and save in your account.
                    </h1>
                    <div className="save-btn">
                        <button onClick={() => {
                            navigate('/login')
                        }}>Login</button>&nbsp;&nbsp;&nbsp;
                        <button style={{ backgroundColor: '#999', color: "#fff" }} onClick={() => {
                            setIsLogin(false)
                        }}>Cancel</button>
                    </div>
                </div>
            </Modal>
        </div >
    )
}
